import { render } from "./ObservePage.vue?vue&type=template&id=08e4b8c0"
import script from "./ObservePage.vue?vue&type=script&lang=js"
export * from "./ObservePage.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./ObservePage.vue?vue&type=style&index=0&id=08e4b8c0&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script